export enum ControlResultState {
  Released = 1,
  Blocked = 2
}
export type ControlResultStateKeys = keyof typeof ControlResultState
export type OperateStateValues = (typeof ControlResultState)[ControlResultStateKeys]
export const ControlResultText: Record<OperateStateValues, string> = {
  1: '已放行',
  2: '已阻断',
}